// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3sao0","inputWrap":"styles_inputWrap__3zQvj","input":"styles_input__3Yc2F"};